import { isArray, isObject } from 'lodash';
import React, { useRef, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { CurrentYearItemRenderer } from '../CurrentYearDropdown';

function NewCommonMultiSelect({
  label,
  index,
  onChange,
  selectedValue,
  optionList,
  selectLabel,
  dataPlaceholder,
  selectValue,
  disable,
  required,
  marginBottomZero,
  hideTitle,
  // valueSupportList is used ONLY to resolve and render selected tags.
  // This lets us show saved inactive items in the input while keeping dropdown options active-only.
  valueSupportList,
  onMenuOpen,
  onMenuClose,
  scrollToCurrentYear,
}) {
  const previousSelectedValueRef = useRef(selectedValue || []);

  useEffect(() => {
    previousSelectedValueRef.current = selectedValue || [];
  }, [selectedValue]);

  let isOptionObjectType = false;
  if (isArray(selectedValue) && isObject(selectedValue[0])) {
    isOptionObjectType = true;
  }
  // Map helper to assign label/value keys expected by MultiSelect
  const mapOptions = (list = []) =>
    (list || []).map((e) => {
      // Fallbacks for label in case some catalogs use different key (e.g., categoryValue)
      const lbl = e?.[selectLabel] ?? e?.name ?? e?.categoryValue ?? e?.label;
      e.label = lbl;
      e.value = e?.[selectValue];
      return e;
    });

  // Dropdown options: strictly from optionList
  const optionsMapped = mapOptions(optionList || []);
  // Selected tags resolution: from valueSupportList (fallback to optionList)
  const valueCandidates = mapOptions(valueSupportList || optionList || []);
  const selectedResolved = (valueCandidates || []).filter((element) => {
    // if (isOptionObjectType) {
    //   const find = (selectedValue || [])?.find((valFind) => valFind?.[selectValue] === element?.[selectValue]);
    //   return !!find;
    // }
    // return (selectedValue || [])?.includes(element?.[selectValue]);
    const isSelected = isOptionObjectType
      ? (selectedValue || [])?.find((valFind) => valFind?.[selectValue] === element?.[selectValue])
      : (selectedValue || [])?.includes(element?.[selectValue]);

    if (isSelected) return true;
    if ((!selectedValue || selectedValue.length === 0) && element?.isDefault) {
      return true;
    }

    return false;
  });

  const handleChange = (selected) => {
    const previousSelected = previousSelectedValueRef.current || [];
    const newSelectedValues = selected.map((e) => e?.[selectValue]);

    const previousSelectedValues = isOptionObjectType ? previousSelected.map((prev) => prev?.[selectValue]) : previousSelected;

    const disabledOptionsInPreviousSelection = optionsMapped.filter((option) => {
      if (!option.disabled) return false;
      return previousSelectedValues.includes(option.value);
    });

    const disabledOptionValues = disabledOptionsInPreviousSelection.map((opt) => opt.value);

    const finalSelectedValues = [...new Set([...newSelectedValues, ...disabledOptionValues])];

    onChange(finalSelectedValues, label, index);
  };

  return (
    <div className={`${marginBottomZero && 'mb-0'} common-react-select multiselect-new`}>
      {!hideTitle && (
        <p className="field-name">
          {label}
          {required && <span className="asterisk">*</span>}
        </p>
      )}
      <MultiSelect
        name={label}
        key={`${label}_${index}`}
        options={optionsMapped}
        className=" common-new-multiselect w-100"
        value={selectedResolved}
        valueRenderer={(selected) => {
          const total = optionsMapped?.length || 0;
          const selCount = selected?.length || 0;
          if (!selCount) return dataPlaceholder ? `Select ${dataPlaceholder}` : `Select ${label}`;
          if (total > 0 && selCount === total) return 'All items are selected.';
          const names = selected.map((s) => s?.label).filter(Boolean);
          const first = names.slice(0, 3).join(', ');
          const extra = names.length > 3 ? ` +${names.length - 3}` : '';
          return `${first}${extra}`;
        }}
        overrideStrings={{
          selectSomeItems: dataPlaceholder ? `Select ${dataPlaceholder}` : `Select ${label}`,
        }}
        labelledBy={dataPlaceholder ? `Select ${dataPlaceholder}` : `Select ${label}`}
        disabled={disable}
        ItemRenderer={scrollToCurrentYear ? CurrentYearItemRenderer : undefined}
        onChange={handleChange}
        onMenuToggle={(isOpen) => {
          if (isOpen) onMenuOpen?.();
          else onMenuClose?.();
        }}
      />
    </div>
  );
}

export default NewCommonMultiSelect;
